// extracted by mini-css-extract-plugin
export default {"featureCardGroup":"OrderList_featureCardGroup__94W66","refunded":"OrderList_refunded__qXypR","badge":"OrderList_badge__wIy-J"};